
export function delay(timeInMs?: number, signal?: AbortSignal) {
  return new Promise<void>(resolve => {
    const timeout = setTimeout(resolve, timeInMs);

    signal?.addEventListener('abort', () => {
      clearTimeout(timeout);
      resolve();
    });
  });
}
